import script from "./Srq20Flow.vue?vue&type=script&setup=true&lang=js"
export * from "./Srq20Flow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__